var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Envelope50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f5c276",
    d: "M1.5 5.5H28.5V24.5H1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c29653",
    d: "M28,6v18H2V6H28 M29,5H1v20h28V5L29,5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#c29653",
    d: "M15,17c-0.7,0-1.5-0.2-2.1-0.5L1.3,10.2l0.5-0.9l11.6,6.2c1,0.6,2.3,0.6,3.3,0l11.6-6.2l0.5,0.9 l-11.6,6.2C16.5,16.8,15.7,17,15,17z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Envelope50);
export default __webpack_public_path__ + "static/media/icons8-envelope-50.161a22719ae40b571c2ee23b8a367b0f.svg";
export { ForwardRef as ReactComponent };